export default __webpack_public_path__ + "static/media/thescotts.79c1ff72.png";